import React from "react";

import { FieldOption } from "components/FieldSelect/FieldSelect";
import ModalFieldSelect from "components/ModalFieldSelect";
import { getTimezoneOptions } from "services/getTimezoneOptions";

type Props = {
	isUnlocked: boolean;
	onOK: (arg: FieldOption[]) => void;
	initialValue: string;
};

function ModalFieldTimezone({ isUnlocked, onOK, initialValue }: Props) {
	return (
		<ModalFieldSelect
			isUnlocked={isUnlocked}
			formatSelectedOption={formatSelectedTimezone}
			title="Timezone"
			requireSelection
			onOK={onOK}
			options={getTimezoneOptions(initialValue)}
			allowMultipleSelections={false}
		/>
	);
}

export default ModalFieldTimezone;

function formatSelectedTimezone(opt: FieldOption) {
	if (typeof opt.value !== "string") {
		throw new Error("Supplied value was not a string");
	}
	return opt.value.indexOf("/") === -1 ? opt.value : opt.value.split("/")[1];
}
